<ion-toolbar class="main-header-toolbar">
    <app-student-header></app-student-header>
</ion-toolbar>

<ion-content [fullscreen]="true" class="content">
    <!--refresher-->
    <ion-refresher class="ion-hide-sm-up" slot="fixed" [pullFactor]="0.5" [pullMin]="100"
                   (ionRefresh)="refresh($event)">

        <ion-refresher-content></ion-refresher-content>

    </ion-refresher>
    <!--refresher end-->

    <ion-grid fixed class="page-grid no-margin-top student-grid student-page"  *transloco="let t; read: 'studentProgress'">

        <app-semi-header [title]="'headerComp.headerPopover.myProgress'|transloco" [withShadow]="showFutureProgress"></app-semi-header>

        <ion-row class=" ion-no-padding" *ngIf="!showFutureProgress">
            <ion-col size="12" class="ion-no-margin ion-no-padding">

                <app-tabs [styleGroup]="true" [studentStyle]="true">

<!--                    <app-tab [tabTitle]="group.title |transloco" [active]="targetGroup == group.id.toString()"-->
<!--                             *ngFor="let group of this.groupsProgress; let j = index">-->
                    <app-tab [tabTitle]="group.title" [active]="targetGroup == group.id.toString()"
                             *ngFor="let group of this.groupsProgress; let j = index">

                        <ion-row class="study-content ion-no-padding">

                            <ion-col size="12" class="ion-no-padding ion-no-margin white-col">
                                <ion-grid class="ion-no-padding ion-no-margin" *ngIf="this.groupsProgress">

                                    <div class="progress-wrapper" #container>

                                        <div class="ion-margin-bottom block"
                                             *ngFor="let block of group.blocks; let i = index">
                                            <div slot="header" (click)="showMoreInfo(j,i, block)"
                                                 class=" item-block item-block-{{block.id}}"
                                                 [ngClass]="{'open' : block.show}">

                                                <div class="image">

                                                    <div class="progress" *ngIf="block.passedPercentage === 100">
                                                        <img src="assets/images/icons/check_mark.svg"/>
                                                    </div>

                                                    <round-progress class="progress"
                                                                    *ngIf="block.passedPercentage !== 100"
                                                                    [current]="block.passedPercentage"
                                                                    [max]="100"
                                                                    [rounded]="true"
                                                                    [color]="'#83B25F'"
                                                                    [background]="'white'"
                                                                    [duration]="800"
                                                                    [animation]="'easeInOutQuart'"
                                                                    [animationDelay]="0"
                                                    />


                                                </div>

                                                <div class="info">
                                                    <div class="start">
                                                        <div class="block-title">{{ block.title }}
                                                            <span *ngIf="block?.show && block?.date">({{ block.date }}
                                                                )</span>

                                                            <span *ngFor="let exam of block.exams, let z = index"
                                                                  class="ion-hide-sm-up hover-info">
                                                                         <span
                                                                             class="end"
                                                                             *ngIf="exam.failed !== false && exam.alreadyStarted"
                                                                             (click)="openPopover($event)">
                                                                        <img
                                                                            src="assets/images/icons/attention_16x16.svg"
                                                                            alt="info">
                                                                    </span>

                                                                    <span *ngIf="exam.failed === false" class="end">
                                                                        <img src="assets/images/icons/done_green.svg"
                                                                             alt="info">
                                                                    </span>

                                                                  <div
                                                                      *ngIf="exam.failed !== false && exam.alreadyStarted == true"
                                                                      class="study-progress" id="study-progress">
                                                                    <div>
                                                                        <div class="ion-padding popover-content">
                                                                            <div class="title ">

                                                                                {{t('youDidNotPass')}}
                                                                            </div>

                                                                            {{t('notPassInfo')}}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                    </span>
                                                        </div>

                                                        <div class="title-wrapper">
                                                            <div class="unit-titles">
                                                                <span
                                                                    *ngFor="let title of block.subtitles; let i = index"
                                                                    [ngClass]="{'d-none':i >= this.maxShowTitle && !showHiddenTitles}">
                                                                <ng-container>

                                                                    <svg width="4" height="4"
                                                                         viewBox="0 0 4 4"
                                                                         fill="none"
                                                                         xmlns="http://www.w3.org/2000/svg">
                                                                        <rect width="4" height="4" rx="2"
                                                                              fill="#83B25F"/>
                                                                    </svg>

                                                                    {{ title }}

                                                                </ng-container>

                                                                </span>
                                                            </div>

                                                            <div *ngIf="block.subtitles.length > 3"
                                                                 class="show-title-wrapper addition-{{block.id}}"
                                                                 (click)="toggleHiddenTitles($event, block)">
                                                                <svg
                                                                    class="margin-line" width="4" height="4"
                                                                    viewBox="0 0 4 4"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg">
                                                                    <rect width="4" height="4" rx="2"
                                                                          fill="#83B25F"/>
                                                                </svg>

                                                                <span
                                                                    class="addition">+{{ block.subtitles.length - 3 }}</span>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div class="end">
                                                        <div *ngFor="let exam of block.exams, let z = index"
                                                             class="hover-info">
                                                            <div class="end ion-hide-sm-down"
                                                                 *ngIf="exam.failed  !== false   && exam.alreadyStarted">
                                                                <img src="assets/images/icons/attention.svg" alt="info">
                                                            </div>

                                                            <div *ngIf="exam.failed === false"
                                                                 class="end ion-hide-sm-down">
                                                                <img src="assets/images/icons/done_green.svg"
                                                                     alt="info">
                                                            </div>

                                                            <div
                                                                *ngIf="exam.failed !== false  && exam.alreadyStarted == true"
                                                                class="study-progress">
                                                                <div>
                                                                    <div class="ion-padding popover-content">
                                                                        <div class="title ">
                                                                            {{ t('youDidNotPass') }}
                                                                        </div>

                                                                        {{ t('notPassInfo') }}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>


                                                        <div class="arrow arrow_{{i}}"></div>

                                                    </div>


                                                </div>

                                            </div>
                                            <div class="details  content_{{j}}_{{i}}"
                                                 [ngClass]="{'d-none': !block.show}">

                                                <div class="slider">
                                                    <swiper-container [slidesPerView]="4" [spaceBetween]="12"
                                                                      [navigation]="true"
                                                                      [breakpoints]="swiperBreakpoints"
                                                                      #swiper>
                                                        <swiper-slide class="slide"
                                                                      [ngClass]="{'not-started': !unit.passed && !unit.completed}"
                                                                      *ngFor="let unit of block.units; let i = index">

                                                            <div class="title">
                                                                <div>{{ unit.title }}</div>
                                                                <div *ngIf="unit.passed || unit.completed ">
                                                                    <img *ngIf=" unit.completed >= 55"
                                                                         src="assets/images/icons/done_green.svg"
                                                                         alt="done">

                                                                    <img *ngIf=" unit.completed < 55"
                                                                         src="assets/images/icons/attention.svg"
                                                                         alt="done">
                                                                </div>
                                                            </div>
                                                            <div class="info-top">
                                                                {{ t('done') }}: {{ unit.passed || unit.completed ? unit.completed : '_' }}
                                                                %
                                                            </div>
                                                            <div class="info-bottom">
                                                                {{ t('correct') }}: {{ unit.passed || unit.completed ? unit.correct : '_' }}
                                                                %
                                                            </div>

                                                        </swiper-slide>


                                                    </swiper-container>

                                                    <ng-container *ngIf="block.units.length > 4"
                                                                  class="ion-hide-sm-down">

                                                        <div (click)="onSlidePrev(swiper)"
                                                             class="swiper-button-prev"></div>
                                                        <div (click)="onSlideNext(swiper)"
                                                             class="swiper-button-next"></div>

                                                    </ng-container>

                                                    <ng-container *ngIf="block.units.length > 2" class="ion-hide-sm-up">

                                                        <div (click)="onSlidePrev(swiper)"
                                                             class="swiper-button-prev"></div>
                                                        <div (click)="onSlideNext(swiper)"
                                                             class="swiper-button-next"></div>

                                                    </ng-container>

                                                </div>


                                                <div class="statistics" *ngIf="block.statistics.length>0">
                                                    <div class="item" *ngFor="let statistic of block.statistics">
                                                        <div class="title">
                                                            {{  statistic.title }}
                                                        </div>

                                                        <div class="block">
                                                            <div class="start">

                                                                <div class="teaser">
                                                                    {{ t('done') }}: {{  statistic.completed }}/{{  statistic.total }}
                                                                </div>

                                                                <div class="progress-container">
                                                                    <div class="progress-bar"
                                                                         [ngStyle]="{ 'width': statistic.completedPercent + '%' }"></div>
                                                                </div>
                                                            </div>
                                                            <div class="end">{{ statistic.completedPercent }}%</div>
                                                        </div>

                                                        <div class="block">
                                                            <div class="start">

                                                                <div class="teaser">
                                                                    {{ t('correct') }}: {{  statistic.correctTask }}/{{  statistic.totalTasks }}
                                                                </div>

                                                                <div class="progress-container">
                                                                    <div class="progress-bar"
                                                                         [ngStyle]="{ 'width': statistic.correctPercent + '%' }"></div>
                                                                </div>
                                                            </div>
                                                            <div class="end">{{ statistic.correctPercent }}%</div>
                                                        </div>

                                                    </div>

                                                </div>

                                                <div class="exam-wrapper" *ngFor="let exam of block.exams">

                                                    <div class="inner-wrapper">
                                                        <div class="title">{{ exam.title }}</div>

                                                        <div class="result-wrapper"
                                                             *ngIf="exam.status ==='finished'">

                                                            <div class="result">
                                                                <div class="title">{{ t('result') }}:</div>
                                                                <div class="score">{{ exam.result }}/50
                                                                    <div class="score-mark"
                                                                         *ngIf="exam?.maxMark === 30 && exam?.evaluation?.online">
                                                                        <img src="assets/images/icons/info24x24.svg"
                                                                             alt="info">

                                                                        <div class="evaluation-popover d-none">

                                                                            <div class="info">

                                                                                <img
                                                                                    src="assets/images/icons/globe_green.svg"
                                                                                    alt="test">

                                                                               {{ t('onlineTest') }}: {{ exam.evaluation?.online }}
                                                                                /30
                                                                            </div>

                                                                            <div class="info">

                                                                                <img
                                                                                    src="assets/images/icons/thought_green.svg"
                                                                                    alt="speaking">
                                                                                 {{ t('speakingPart') }}: {{ exam.evaluation?.speaking ?? '-' }}
                                                                                /{{ exam.isSpeakingWithEngCourse ? '20' : '10' }}

                                                                            </div>
                                                                            <div class="info"
                                                                                 *ngIf="!exam.isSpeakingWithEngCourse">

                                                                                <img
                                                                                    src="assets/images/icons/pan_green.svg"
                                                                                    alt="writing">
                                                                                {{ t('writingPart') }}: {{ exam.evaluation?.writing ?? '-' }}
                                                                                /10

                                                                            </div>


                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="result">
                                                                <div class="title"> {{t('attemptsUsed') }}:</div>
                                                                <div class="score">{{ exam.try }}</div>
                                                            </div>

                                                            <div class="image-wrapper">
                                                                <img src="assets/images/icons/score_yellow.svg"
                                                                     alt="evaluation failed" *ngIf="exam.failed ">

                                                                <img src="assets/images/icons/score_green.svg"
                                                                     alt="evaluation" *ngIf="!exam.failed">
                                                            </div>


                                                        </div>

                                                        <div class="result-wrapper"
                                                             *ngIf="exam.status !=='finished'">

                                                            <div class="result">
                                                                <div class="title">{{t('availableFrom') }}:</div>
                                                                <div class="date"
                                                                >{{ exam.startAt }}
                                                                </div>
                                                            </div>

                                                            <div class="result">
                                                                <div class="title">{{t('availableUntil') }}:</div>
                                                                <div class="date"
                                                                     [ngClass]="{'expired': exam.passed}">{{ exam.endAt }}
                                                                </div>
                                                            </div>

                                                            <div class="image-wrapper">
                                                                <img src="assets/images/icons/attention_yellow.svg">
                                                            </div>


                                                        </div>

                                                        <!--                                                            <button-->
                                                        <!--                                                                [ngClass]="{ 'btn dark-btn': true, 'disable': exam.status !== 'finished' && !exam.passed }">-->
                                                        <!--                                                                {{ getButtonText(exam) }}-->
                                                        <!--                                                                <img src="assets/images/icons/eye.svg" alt="eye">-->
                                                        <!--                                                            </button>-->

                                                        <button type="button" class="btn dark-btn"
                                                                *ngIf="exam.status === 'finished'"
                                                                (click)="getResultExam(exam.uuid)">
                                                            {{t('check') }}
                                                            <img src="assets/images/icons/eye.svg" alt="eye">
                                                        </button>

                                                        <button type="button" class="btn dark-btn disable"
                                                                *ngIf="exam.status !== 'finished' && !exam.passed">
                                                            {{t('check') }}
                                                            <img src="assets/images/icons/eye.svg" alt="eye">
                                                        </button>

                                                        <button type="button" class="btn dark-btn"
                                                                *ngIf="exam.status !== 'finished' && exam.passed"
                                                                (click)="openRequestModal('continueAccessTest')">
                                                            {{t('requestAccess') }}
                                                            <!--                                                                <img src="assets/images/icons/eye.svg" alt="eye">-->
                                                        </button>


                                                    </div>


                                                    <img src="assets/images/note.png" class="image">

                                                </div>


                                            </div>
                                        </div>
                                    </div>

                                </ion-grid>

                            </ion-col>
                        </ion-row>


                    </app-tab>
                </app-tabs>

            </ion-col>

        </ion-row>


        <ion-row class=" ion-no-padding with-margin-top " *ngIf="showFutureProgress">
            <ion-col size="12" class="ion-no-margin ion-no-padding">

                <ion-row class="study-content ion-no-padding">

                    <ion-col size="12" class="ion-no-padding ion-no-margin white-col">
                        <app-dummy [type]="'study_progress'" [isImageBig] = "true"></app-dummy>
<!--                        <img src="assets/images/dummies/empty_study_history.png" alt="no study history yet">-->
                    </ion-col>
                </ion-row>


            </ion-col>
        </ion-row>


    </ion-grid>

    <app-footer></app-footer>

</ion-content>
